export function ariareaderviewRender() { return `<div class="aria-reader" aria-live="polite"></div>` }